import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useNavigate } from 'react-router-dom';
import styled, { css } from 'styled-components/macro';
import { WxLabel, WxText } from '../..';
import { OrderItemType } from '../../../hooks/api/queries/useOrder';
import { __ } from '../../../i18n/l10n';
import { appendCommitHash } from '../../../utils/appendHash';
import { splitNumber } from '../../../utils/splitNumber';
import { WImage } from '../../ui/image/Image';

interface Props {
  item: OrderItemType;
}

export const OrderItemCard = ({ item }: Props) => {
  const navigate = useNavigate();
  return (
    <Wrapper>
      <ImageDiv
        onClick={() => navigate(appendCommitHash(`/product/${item.slug}`))}
      >
        <WImage
          image={
            item.localizedVariantImage ??
            item.defaultVariantImage ??
            item.localizedProductImage ??
            item.defaultProductImage
          }
          background
        />
      </ImageDiv>
      <InfoDiv>
        <TopDiv>
          <WxLabel label={item.label} />
          <WxLabel label={`x${item.quantity}`} noUppercase />
        </TopDiv>
        <MiddleDiv>
          {item.attributes
            ?.sort((a, b) => {
              if (a.keySorting === null) return 1;
              else if (b.keySorting === null) return -1;
              else return a.keySorting - b.keySorting;
            })
            .map((attr) => (
              <li key={`${item.id}-${attr.id}`}>
                <WxText darkMode text={attr.label} />
              </li>
            ))}
        </MiddleDiv>
        <BottomDiv>
          <WxLabel
            label={`${splitNumber(item.totalMilesAmount)} ${__('MILES')}`}
          />
        </BottomDiv>
      </InfoDiv>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  gap: 0.625rem;
`;

export const StyledFontAwesomeIcon = styled(FontAwesomeIcon)<{
  disabled?: boolean;
}>`
  font-weight: 900;
  cursor: pointer;

  ${({ disabled }) =>
    disabled &&
    css`
      pointer-events: none;
      cursor: pointer;
      opacity: 0.3;
    `};
`;

const InfoDiv = styled.div`
  width: calc(66% - 0.3125rem);
  display: flex;
  flex-direction: column;
  padding-top: 0.625rem;
`;

const TopDiv = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 0.9575rem;

  > :last-child {
    display: flex;
    gap: 0.8125rem;
  }
`;

const BottomDiv = styled.div`
  margin-top: auto;
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
`;

const MiddleDiv = styled.ul`
  text-align: left;
  margin-top: 0.625rem;

  > li {
    margin-bottom: 0.625rem;
  }
`;

const ImageDiv = styled.div`
  width: calc(34% - 0.3125rem);
  cursor: pointer;
`;
